export default {
  createButton: { id: 'create_button' },
  licenseeInfo: { id: 'licensee_info' },
  setApplications: { id: 'set_applications' },
  changeLogo: { id: 'change_logo' },
  saveInfo: { id: 'save_info' },
  locusInfo: { id: 'locus_info' },
  licenseeLogo: { id: 'licensee_logo' },
  save: { id: 'save' },
  cancel: { id: 'cancel' },
  name: { id: 'name' },
  visible: { id: 'visible_in_ui' },
  updateLogo: { id: 'update_logo' },
  imageTypeSVG: { id: 'image_type_only_svg' },
  latinDigitalFormat: { id: 'latin_digital_format' },
  copyDataFrom: { id: 'copy_data_from' },
  usaDateFormat: { id: 'usa_date_format' },
  usaTimeFormat: { id: 'usa_time_format' },
  mobileJobSyncDaysPast: { id: 'mobile_job_sync_days_past' },
  mobileJobSyncDaysAhead: { id: 'mobile_job_sync_days_ahead' },
}
